import { helper } from '@ember/component/helper';

export const abs = (params) => {
  if (params[0] === null || params[0] === undefined) return null;
  return Math.abs(params[0]);
};

export default helper(abs);
